define((require, exports, module) => {
    'use strict';

    const AsyncRepeat = require('../async/AsyncRepeat');
    const UploadReason = require('../../UploadReason');
    const JavaScriptError = require('../../errors/JavaScriptError');
    const LocalFileNotFoundFail = require('../../fails/LocalFileNotFoundFail');

    /**
     * @namespace
     */
    const fileSystemEntryReader = {
        /**
         * @param {FileEntry} entry
         * @returns {Promise}
         * @resolves {File}
         * @rejects {Error}
         */
        getFile(entry) {
            let promise = new Promise((resolve, reject) => {
                entry.file(resolve, reject);
            });

            promise = promise.catch((error) => {
                const source = UploadReason.SOURCE_WEB_CLIENT;
                let stack;
                let reason;

                if (LocalFileNotFoundFail.isNotFoundError(error)) {
                    stack = new Error('LocalFileNotFoundFail');
                    reason = new LocalFileNotFoundFail(stack, source);
                } else {
                    stack = new Error('JavaScriptError');
                    reason = new JavaScriptError(stack, source, error);
                }

                return Promise.reject(reason);
            });

            return promise;
        },

        /**
         * @param {DirectoryEntry} entry
         * @returns {Promise}
         * @resolves {DirectoryReader}
         * @rejects {Error}
         */
        createReader(entry) {
            return new Promise((resolve) => {
                const reader = entry.createReader();

                resolve(reader);
            });
        },

        /**
         * @param {DirectoryReader} reader
         * @returns {Promise}
         * @resolves {Array.<FileEntry|DirectoryEntry>}
         * @rejects {Error}
         */
        readEntries(reader) {
            return new Promise((resolve, reject) => {
                reader.readEntries(resolve, reject);
            });
        },

        /**
         * @param {DirectoryReader} reader
         * @returns {Promise}
         * @resolves {Array.<FileEntry|DirectoryEntry>}
         * @rejects {Error}
         */
        _readDirectory(reader) {
            // @type {Array.<FileEntry|DirectoryEntry>}
            const result = [];
            return new AsyncRepeat((repeat, finish, thrower) => {
                let promise = fileSystemEntryReader.readEntries(reader);

                promise = promise.then((entries) => {
                    const count = entries.length;

                    // entries может быть объектом, похожим на Array,
                    // поэтому конкатинируем коллекции в цикле.
                    for (let i = 0, j = result.length; i < count; i++, j++) {
                        result[j] = entries[i];
                    }

                    if (count) {
                        // DirectoryReader может отдавать entries порциями,
                        // поэтому повторяем действия, пока получаем
                        // коллекцию ненулевой длины.
                        repeat();
                    } else {
                        finish(result);
                    }
                });

                promise.catch((reason) => {
                    thrower(reason);
                });
            });
        },

        /**
         * @param {DirectoryEntry} entry
         * @returns {Promise}
         * @resolves {Array.<FileEntry|DirectoryEntry>}
         * @rejects {Error}
         */
        readDirectory(entry) {
            let promise = fileSystemEntryReader.createReader(entry);

            promise = promise.then(fileSystemEntryReader._readDirectory);

            return promise;
        },
    };

    module.exports = fileSystemEntryReader;
});
